import React, { useState } from "react";
import { Container, Row, Col, Card, Button, Table, Form, Modal } from "react-bootstrap";
import { useAccounts } from "../../contextjs/AccountContext";
import "../../App.css";
import { useNavigate } from "react-router-dom";
// import { useLedgerReports } from "../../contextjs/LedgerReportsContext";
import LedgerReports from "./reportsmodules/ledgerreports";

const Accounts = () => {
    const { accounts, accountTypes, loading, createNewAccount, updateExistingAccount, removeAccount, createNewAccountType,
        updateExistingAccountType, removeAccountType} = useAccounts();
    const [showModal, setShowModal] = useState(false);
    const [showTypeModal, setShowTypeModal] = useState(false);
    const [newAccount, setNewAccount] = useState({ account_type: "", account_name: "", account_details: "",
        opening_balance: 0 });
    const [newAccountType, setNewAccountType] = useState({ account_type_name: "", account_type_description: "" });
    const [showAccountTypeList, setShowAccountTypeList] = useState(false);
    const [currentAccount, setCurrentAccount] = useState(null);
    const [currentAccountType, setCurrentAccountType] = useState(null);
    //added
    const isSuperUser = true; // assuming I'm the superuser in development
    //end of added

    // filter accounts based on account type and account name
    const [accountTypeFilter, setAccountTypeFilter] = useState("");
    const [accountNameFilter, setAccountNameFilter] = useState("");

    //state for to show accounts in account type
    const [showAccountsListModal, setShowAccountsListModal] = useState(false);
    const [selectedAccountType, setSelectedAccountType] = useState(null);

    //states for ledger report modal
    const [showLedgerReportModal, setShowLedgerReportModal] = useState(false);
    const [selectedAccountForLedger, setSelectedAccountForLedger] = useState(null);

    const navigate = useNavigate();

    const handleBack = () => {
        navigate(-1); // go back to previous page
    };

    const handleShowModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);

    const handleShowTypeModal = () => {
        setNewAccountType({ account_type_name: "", account_type_description: "" });
        setCurrentAccountType(null);
        setShowTypeModal(true);
    };
    const handleCloseTypeModal = () => setShowTypeModal(false);

    const handleShowAccountTypeList = () => setShowAccountTypeList(true);
    const handleCloseAccountTypeList = () => setShowAccountTypeList(false);


    const handleInputChange =(e) => {
        const { name, value } = e.target;
        setNewAccount({ ...newAccount, [name]: value });
    };

    const handleTypeInputChange =(e) => {
        const { name, value } = e.target;
        setNewAccountType({ ...newAccountType, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if(currentAccount){
            await updateExistingAccount({...currentAccount, ...newAccount});
        } else {
            await createNewAccount(newAccount);
        }
        setNewAccount({ account_type: "", account_name: "", account_details: "", opening_balance: 0 });
        setCurrentAccount(null);
        handleCloseModal();
    };

    const handleTypeSubmit = async (e) => {
        e.preventDefault();
        if (currentAccountType) {
            await updateExistingAccountType({...currentAccountType, ...newAccountType});
        } else {
            await createNewAccountType(newAccountType);
        }
        setNewAccountType({ account_type_name: "", account_type_description: "" });
        setCurrentAccountType(null);
        handleCloseTypeModal();
    };

    const handleEditAccount = async (account) => {
        setCurrentAccount(account);
        setNewAccount({
            // account_type: account.account_type.id,
            account_type: account.account_type?.id || account.account_type,
            account_name: account.account_name,
            account_details: account.account_details || "",
            // account_balance: account.account_balance,
            opening_balance: account.opening_balance //initialize with existing opening balance
        });
        setShowModal(true);
    };

    const handleDeleteAccount = async (id) => {
        // await removeAccount(id);
        const isConfirmed = window.confirm("Are you sure you want to delete this account?");
        if (isConfirmed) {
            await removeAccount(id);
        }
    };

    const handleEditAccountType = (type) => {
        setCurrentAccountType(type);
        setNewAccountType({
            account_type_name: type.account_type_name,
            account_type_description: type.account_type_description
        });
        setShowTypeModal(true);
    };

    const handleDeleteAccountType = async (id) => {
        // await removeAccountType(id);
        const isConfirmed = window.confirm("Are you sure you want to delete this account type?");
        if (isConfirmed) {
            await removeAccountType(id);
        }
    };

    // account list in account type functions
    const handleShowAccountsList = (type) => {
        setSelectedAccountType(type);
        setShowAccountsListModal(true);
    };

    const handleCloseAccountsList = () => {
        setSelectedAccountType(null);
        setShowAccountsListModal(false);
    };

    // filter accounts based on account type and account name
    const filteredAccounts = accounts.filter(account => {
        const matchesType = accountTypeFilter? account.account_type_details.account_type_name.includes(accountTypeFilter) : true;
        const matchesName = accountNameFilter? account.account_name.toLowerCase().includes(accountNameFilter.toLowerCase()) : true;
        return matchesType && matchesName;
    });

    if (loading) {
        return <div>Loading...</div>;
    }

    // handlers for ledger report modal
    const handleShowLedgerReportModal = (account) => {
        setSelectedAccountForLedger(account);
        setShowLedgerReportModal(true);
    };

    const handleCloseLedgerReportModal = () => {
        setShowLedgerReportModal(false);
        setSelectedAccountForLedger(null);
    };

    const formatDrCr = (amount, accountType) => {
        const num = Number(amount || 0);
        const value = Math.abs(num).toLocaleString();

        const debitNormal = ["Asset", "Expense", "Receivable"].includes(accountType);

        if (num === 0) {
            return debitNormal ? `Dr.0` : `Cr.0`;
        }

        if (debitNormal) {
            return num > 0 ? `Dr. ${value}` : `Cr. ${value}`;
        } else {
            return num > 0 ? `Cr. ${value}` : `Dr. ${value}`;
        }
    };

    return (
        <div>
            <div className="back-button-container">
                <Button variant="secondary" onClick={handleBack}>Back</Button>
            </div>
            <Container className="mt-5">
                <h1 className="text-center mb-4">Accounts Overview</h1>
                <Row>
                    <Col md={12} className="mb-4">
                        <Card>
                            <Card.Header className="bg-primary text-white d-flex justify-content-between align-items-center">
                                All Accounts
                                <Button variant="info" size="md" onClick={handleShowAccountTypeList}>Account Types</Button>
                                <Button variant="dark" size="md" onClick={handleShowTypeModal}>Add Account Type</Button>
                                <Button variant="success" size="md" onClick={handleShowModal}>Add Account</Button>
                            </Card.Header>

                            {/*Search input*/}
                            <div className="mt-3 mb-3">
                                <Row className="mb-3">
                                    <Col md={6}>
                                        <Form.Control type="text" placeholder="Search by Account Name" value={accountNameFilter}
                                                      onChange={(e) => setAccountNameFilter(e.target.value)} />
                                    </Col>
                                    <Col md={6}>
                                        <Form.Control as="select" value={accountTypeFilter}
                                                      onChange={(e) => setAccountTypeFilter(e.target.value)}
                                        >
                                            <option value="">All Account Types</option>
                                            {accountTypes.map(type => (
                                                <option key={type.id} value={type.account_type_name}>{type.account_type_name}</option>
                                            ))}
                                        </Form.Control>
                                    </Col>
                                </Row>
                            </div>

                            <Card.Body>
                                <Table striped bordered hover>
                                    <thead>
                                    <tr>
                                        <th>Account Name</th>
                                        <th>Account Number</th>
                                        <th>Balance (KES)</th>
                                        <th>Account Type</th>
                                        <th>Action</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                        {/*{accounts.map(account => (*/}
                                        {filteredAccounts.map(account => (
                                            <tr key={account.id}>
                                                <td>
                                                    <button className="btn btn-link p-0" onClick={() =>
                                                        handleShowLedgerReportModal(account)} style={{ textDecoration: 'none'}}>
                                                        {account.account_name}
                                                    </button>
                                                </td>
                                                <td>{account.account_number}</td>
                                                <td>
                                                    {formatDrCr(account.computed_balance, account.account_type_details.account_type_name)}
                                                </td>
                                                <td>{account.account_type_details.account_type_name}</td>
                                                {/* account_type_details variable from account serializer */}
                                                <td>
                                                    <Button variant="warning" size="sm" onClick={() => handleEditAccount(account)}
                                                     className="button-spacing">Edit</Button>
                                                    <Button variant="danger" size="sm" className="ml-2"
                                                    onClick={() => handleDeleteAccount(account.id)}>Delete</Button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Modal show={showModal} onHide={handleCloseModal}>
                    <Modal.Header closeButton>
                        {/*<Modal.Title>Add New Account</Modal.Title>*/}
                        <Modal.Title>{currentAccount ? "Edit Account" : "Add New Account"}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form onSubmit={handleSubmit}>
                            <Form.Group controlId="formAccountName">
                                <Form.Label>Account Name</Form.Label>
                                <Form.Control type="text" name="account_name" value={newAccount.account_name} onChange={handleInputChange} required />
                            </Form.Group>

                            <Form.Group controlId="formAccountDetails" className="mt-3">
                                <Form.Label>Account Details</Form.Label>
                                <Form.Control as="textarea" rows={3} name="account_details" value={newAccount.account_details} onChange={handleInputChange} />
                            </Form.Group>

                            {/*added*/}
                            <Form.Group controlId="formOpeningBalance" className="mt-3">
                                <Form.Label>Opening Balance</Form.Label>
                                <Form.Control type="number" name="opening_balance" value={newAccount.opening_balance}
                                              onChange={handleInputChange} required disabled={currentAccount && !isSuperUser}
                                    //disable opening balance for non-superusers and editing
                                />
                            </Form.Group>
                            {/*end of added*/}

                            {/*<Form.Group controlId="formAccountBalance" className="mt-3">*/}
                            {/*    <Form.Label>Balance</Form.Label>*/}
                            {/*    <Form.Control type="number" name="account_balance" value={newAccount.account_balance} onChange={handleInputChange} required />*/}
                            {/*</Form.Group>*/}

                            <Form.Group controlId="formAccountType" className="mt-3">
                                <Form.Label>Account Type</Form.Label>
                                <Form.Control as="select" name="account_type" value={newAccount.account_type || currentAccount?.account_type?.id || ''}
                                              onChange={handleInputChange} required>
                                    <option value="">Select Account Type</option>
                                    {accountTypes.map(type => (
                                        <option key={type.id} value={type.id}>{type.account_type_name}</option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                            {/*<Button variant="primary" type="submit" className="mt-3">Add Account</Button>*/}
                            <Button variant="primary" type="submit" className="mt-3">{currentAccount ? "Update Account" : "Add Account"}</Button>
                        </Form>
                    </Modal.Body>
                </Modal>

                {/* Add Account Type Modal */}
                <Modal show={showTypeModal} onHide={handleCloseTypeModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>{currentAccountType ? "Edit Account Type" : "Add New Account Type"}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form onSubmit={handleTypeSubmit}>
                            <Form.Group controlId="formAccountTypeName">
                                <Form.Label>Account Type Name</Form.Label>
                                <Form.Control type="text" name="account_type_name" value={newAccountType.account_type_name}
                                              onChange={handleTypeInputChange} required />
                            </Form.Group>

                            <Form.Group controlId="formAccountTypeDescription" className="mt-3">
                                <Form.Label>Account Type Description</Form.Label>
                                <Form.Control as="textarea" rows={3} name="account_type_description"
                                              value={newAccountType.account_type_description} onChange={handleTypeInputChange} />
                            </Form.Group>
                            <Button variant="info" type="submit" className="mt-3">{currentAccountType ? "Update" : "Add"}</Button>
                        </Form>
                    </Modal.Body>
                </Modal>

                {/* Account Type List Modal */}
                <Modal show={showAccountTypeList} onHide={handleCloseAccountTypeList} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>Account Types</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Table striped bordered hover>
                            <thead>
                            <tr>
                                <th>Account Type Name</th>
                                <th>Account Type Description</th>
                                <th>Action</th>
                            </tr>
                            </thead>
                            <tbody>
                                {accountTypes.map(type => (
                                    <tr key={type.id}>
                                        <td>
                                            <button className="btn btn-link p-0" onClick={() => handleShowAccountsList(type)}>
                                                {type.account_type_name}
                                            </button>
                                        </td>
                                        <td>{type.account_type_description}</td>
                                        <td>
                                            <Button variant="warning" size="sm" onClick={() => handleEditAccountType(type)}
                                             className="button-spacing">Edit</Button>
                                            <Button variant="danger" size="sm" className="ml-2" onClick={() => handleDeleteAccountType(type.id)}>Delete</Button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Modal.Body>
                </Modal>

                {/* Account List in Account Type Modal */}
                <Modal show={showAccountsListModal} onHide={handleCloseAccountsList} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>Accounts in {selectedAccountType?.account_type_name}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Table striped bordered hover>
                            <thead>
                            <tr>
                                <th>Account Name</th>
                                <th>Account Number</th>
                                <th>Balance (KES)</th>
                            </tr>
                            </thead>
                            <tbody>
                                {accounts.filter(account => account.account_type === selectedAccountType?.id).map(account => (
                                    <tr key={account.id}>
                                        <td>{account.account_name}</td>
                                        <th>{account.account_number}</th>
                                        <td>{Number(account.computed_balance || 0).toLocaleString()}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Modal.Body>
                </Modal>

                {/*ledgerReports Modal*/}
                <Modal show={showLedgerReportModal} onHide={handleCloseLedgerReportModal} dialogClassName="modal-xl" centered>
                    <Modal.Body>
                        {selectedAccountForLedger && (
                            <LedgerReports accountId={selectedAccountForLedger.id} onClose={handleCloseLedgerReportModal}/>
                        )}
                    </Modal.Body>
                </Modal>
            </Container>
        </div>
    );
};

export default Accounts;